import clsx from "clsx";

import { LANGS, useLang, useT } from "../../i18n";

/** EN · ՀԱՅ · RU toggle, shared by the header and the footer. */
const LanguageSwitcher = ({ className }: { className?: string }) => {
  const t = useT();
  const { lang, setLang } = useLang();
  return (
    <div
      role="group"
      aria-label={t("header.language")}
      className={clsx("flex items-center gap-0.5 text-[11px] leading-none", className)}
    >
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => setLang(l.code)}
          aria-pressed={lang === l.code}
          className={clsx(
            "bg-transparent border-0 px-[3px] py-1 font-semibold tracking-wide cursor-pointer",
            lang === l.code ? "text-primary" : "text-white/55 hover:text-white",
          )}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
